"use client";

import { IconCheck } from "@tabler/icons-react";
import { useTranslations } from "next-intl";
import { buttonVariants } from "@/components/ui/button";
import { SheetClose } from "@/components/ui/sheet";
import { AUTH_PRIMARY_BUTTON } from "@/features/auth/lib/auth-button-styles";
import { Link } from "@/i18n/navigation";
import { cn } from "@/lib/utils";

const BENEFIT_KEYS = ["menu", "delivery", "discounts"] as const;

/** Signed-out header of the mobile menu: the benefits card with the auth CTA. */
export const MobileMenuBenefits = () => {
  const t = useTranslations("header.menu");

  return (
    <div className="px-4 pt-4 pb-2">
      <div className="flex flex-col gap-4 rounded-xl bg-linear-to-r from-brand-green2-300 from-[17.5%] to-brand-green1-300 to-[72%] px-4 py-6">
        <div className="flex flex-col gap-2">
          <p className="font-medium text-text-inverse text-xl leading-7">
            {t.rich("benefits.title", {
              highlight: (chunks) => (
                <span className="text-brand-yellow">{chunks}</span>
              ),
            })}
          </p>
          <ul className="flex flex-col gap-1">
            {BENEFIT_KEYS.map((key) => (
              <li className="flex items-center gap-2" key={key}>
                <IconCheck
                  aria-hidden="true"
                  className="size-6 shrink-0 text-brand-yellow"
                  strokeWidth={1.5}
                />
                <span className="text-base text-text-inverse leading-6">
                  {t(`benefits.${key}`)}
                </span>
              </li>
            ))}
          </ul>
        </div>
        <SheetClose asChild>
          <Link
            className={cn(
              buttonVariants({ variant: "ghost" }),
              AUTH_PRIMARY_BUTTON
            )}
            data-pw="mobile-menu-sign-in"
            href={{
              pathname: "/sign-in/[[...sign-in]]",
              params: { "sign-in": [] },
            }}
          >
            {t("signInCta")}
          </Link>
        </SheetClose>
      </div>
    </div>
  );
};
